import { useEffect, useState } from "react";
import AppHeader from "../../components/app-header/app-header";
import styles from "./words.module.css";
import Listtem from "../../components/listtem/listtem";
import Cardsw from "../../components/cardsw/cardsw";

function Words() {
  const [name, setname] = useState("...");
  const [slova, setslova] = useState([{ ru: "я", port: "eu" }]);
  const [isVisible, setVisible] = useState(false);

  // Обработчик клика вне списка — внутри useEffect для компактности
  useEffect(() => {
    if (!isVisible) return; // если список скрыт — ничего не делаем

    const handleClick = (evt: any) => {
      if (!evt.target.className.includes("list") && !evt.target.className.includes("res")) {
        setVisible(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => document.removeEventListener("click", handleClick);
  }, [isVisible]);

  return (
    <div className={styles.main}>
      <div className={styles.header}>
        <AppHeader name="Карточки со словами" />
      </div>

      <div className={styles.block}>
        <div className={styles.res} onClick={() => setVisible(true)}>
          {`Тема набора: ${name}`}
        </div>
        <Cardsw list={slova} />
      </div>

      {isVisible && (
        <div className={styles.list}>
          <Listtem setname={setname} setslova={setslova} setv={setVisible} />
        </div>
      )}
    </div>
  );
}

export default Words;
